import { resolveFlowPlanId } from '~/utils/flowPlanId';

/** Monta o path `/personalCoverage?…` para abrir legacy com cotação (após POST /Quotes). */
export function buildPersonalCoverageQuoteUrl(
  args: Readonly<{
    searchParams: Pick<URLSearchParams, 'get'>;
    planIdFromStore: string | null | undefined;
    organizationId: string | null | undefined;
    seller: string | null | undefined;
    quoteHash: string | undefined;
  }>
): string {
  const planParam = resolveFlowPlanId(args.searchParams.get('plan'), args.planIdFromStore ?? undefined);
  const distribuitorParam = args.searchParams.get('dis');
  const orgParam = args.searchParams.get('org') ?? args.organizationId ?? '';
  const sellerParam = args.searchParams.get('seller') ?? args.seller ?? '';
  const queryTail = `${distribuitorParam ? `&dis=${distribuitorParam}` : ''}${orgParam ? `&org=${orgParam}` : ''}${
    sellerParam ? `&seller=${sellerParam}` : ''
  }`;
  if (args.quoteHash) {
    return `/personalCoverage?quote=${args.quoteHash}&plan=${planParam}${queryTail}`;
  }
  return `/personalCoverage?plan=${planParam}${queryTail}`;
}
